import * as d3 from "d3";

export const createScales = (
    data: { name: string| number; value: number }[],
    width: number,
    height: number,
    margin: { top: number; right: number; bottom: number; left: number },
    barPadding: number
) => {
    const boundsWidth = width - margin.left - margin.right;
    const boundsHeight = height - margin.top - margin.bottom;

    const xScale = d3
        .scaleBand()
        .domain(data.map(d => String(d.name)))
        .range([0, boundsWidth])
        .padding(barPadding);

    const maxValue = d3.max(data, d => d.value) ?? 0;

    const yScale = d3
        .scaleLinear()
        .domain([0, maxValue])
        .range([boundsHeight, 0])
        .nice();

    return { xScale, yScale, boundsWidth, boundsHeight };
};
